import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Globe, ChevronDown, Check } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "../i18n";
import { setLanguage } from "../i18n/LanguageService";

/**
 * Pemilih bahasa — tampilan sama dengan dropdown bahasa di sewoork.com.
 * placement "sidebar" (di bawah kartu profil) atau "floating" (pojok kanan atas halaman auth).
 */
const LanguageSwitcher = ({ placement = "sidebar", syncServer = true }) => {
  const { t, i18n } = useTranslation();
  const current =
    SUPPORTED_LANGUAGES.find((lang) => lang.code === i18n.language) ||
    SUPPORTED_LANGUAGES[0];

  return (
    <Dropdown
      className={`sw-lang-switch sw-lang-switch--${placement}`}
      align="end"
      drop={placement === "sidebar" ? "up" : "down"}
      onSelect={(code) => setLanguage(code, { syncServer })}
    >
      <Dropdown.Toggle
        as="button"
        type="button"
        className="sw-lang-switch__toggle"
        aria-label={`${t("language")}: ${current.label}`}
      >
        <Globe size={16} aria-hidden="true" />
        <span className="sw-lang-switch__label">
          {placement === "sidebar" ? current.label : current.short}
        </span>
        <ChevronDown size={14} aria-hidden="true" className="sw-lang-switch__chevron" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="sw-lang-switch__menu">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            eventKey={lang.code}
            active={lang.code === current.code}
            lang={lang.code}
          >
            <span>{lang.label}</span>
            {lang.code === current.code ? (
              <Check size={16} aria-hidden="true" />
            ) : (
              <span className="sw-lang-switch__code">{lang.short}</span>
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
